import PropTypes from "prop-types";

const FormRowSelectId = ({
  name,
  labelText,
  list,
  idField,
  displayField,
  handleChange,
  value,
  defaultValue,
}) => {
  return (
    <div className="form-row">
      <label htmlFor={name} className="form-label">
        {labelText || name}
      </label>
      <select
        name={name}
        id={name}
        onChange={handleChange}
        className="form-select"
        value={value}
        defaultValue={defaultValue}
      >
        <option value="">{defaultValue || "בחר אפשרות"}</option>
        {list.map((item) => (
          <option key={item[idField]} value={item[idField]}>
            {item[displayField]}
          </option>
        ))}
      </select>
    </div>
  );
};

FormRowSelectId.propTypes = {
  name: PropTypes.string.isRequired,
  labelText: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.object).isRequired, // רשימת אובייקטים
  idField: PropTypes.string.isRequired, // שדה ה-ID באובייקט
  displayField: PropTypes.string.isRequired, // שדה התצוגה באובייקט
  handleChange: PropTypes.func.isRequired, // פונקציה לטיפול בשינוי
  value: PropTypes.string, // ערך נוכחי
  defaultValue: PropTypes.string, // ערך ברירת מחדל (אופציונלי)
};

export default FormRowSelectId;
